import { createContext, useContext, useEffect, useState } from 'react';

const SpauthServiceContext = createContext();
export const useSpauth = () => useContext(SpauthServiceContext);

export const Spauth = ({ appId, children }) => {
  const [userObj, setUserObj] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const login = async () => {
      if (!window.SPAUTH) {
        if (!cancelled) setUserObj({});
        return;
      }
      try {
        const userInfo = await window.SPAUTH.appId(appId).useJWTforXHR().login();
        if (!cancelled) setUserObj(userInfo ?? {});
      } catch {
        if (!cancelled) setUserObj({});
      }
    };
    login();
    return () => {
      cancelled = true;
    };
  }, [appId]);

  if (userObj === null) return null;

  return (
    <SpauthServiceContext.Provider value={userObj}>
      {children}
    </SpauthServiceContext.Provider>
  );
};
